import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_15: FaireProductEntity = {
  token: "sweet-wink-15",
  type: "product",
  name: "XOXO Sequin Patch Valentine's Day Sweatshirt - Kids Clothing",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/8e95926fa235a40fa2e892d0759f49591a16e62e938706625b750b0dd6999573.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 22,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
